module.exports = __webpack_public_path__ + "static/media/39-10.14fe577d.mp3";